import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { CustomerInitialState } from './customerTypes';
import { addPaymentCard, getCustomerById, getCustomerByOrganizationId, updateCustomer, updateCustomerDefaultPaymentMethod } from './customerActions';

const initialState: CustomerInitialState = {
  customerInfo: {
    id: "",
    name: "",
    email: "",
    currency: "",
    defaultPaymentMethodId: "",
    paymentMethodType: "",
    cardBrand: "",
    cardLast4: "",
    cardExpMonth: 0,
    cardExpYear: 0,
  },
  isLoading: false,
};

export const customerSlice = createSlice({
  name: '@@subscription',
  initialState,
  reducers: {},
  extraReducers: (builder) => {  
    builder.addCase(getCustomerById.fulfilled, (state, action) => {
      state.customerInfo = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getCustomerById.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getCustomerById.pending, (state) => {
      state.isLoading = true;
    });
    
    builder.addCase(getCustomerByOrganizationId.fulfilled, (state, action) => {
      state.customerInfo = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getCustomerByOrganizationId.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getCustomerByOrganizationId.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(updateCustomer.fulfilled, (state, action) => {
      state.customerInfo = action.payload;
      state.isLoading = false;
    });
    builder.addCase(updateCustomer.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(updateCustomer.pending, (state) => {
      state.isLoading = true;
    });
    
    builder.addCase(addPaymentCard.fulfilled, (state, action) => {
      state.customerInfo = action.payload;
      state.isLoading = false;
    });
    builder.addCase(addPaymentCard.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(addPaymentCard.pending, (state) => {
      state.isLoading = true;
    });
    
    builder.addCase(updateCustomerDefaultPaymentMethod.fulfilled, (state, action) => {
      state.customerInfo = action.payload;
      state.isLoading = false;
    });
    builder.addCase(updateCustomerDefaultPaymentMethod.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(updateCustomerDefaultPaymentMethod.pending, (state) => {
      state.isLoading = true;
    });
  },
});

export const customerInfoSelector = createSelector(
  [(state: RootState) => state.customer.customerInfo],
  (info) => info
);

export const isLoadingCustomerInfoSelector = createSelector(
  [(state: RootState) => state.customer.isLoading],
  (isLoading) => isLoading
);
